<template>
  <section
    :class="[
      'public-shareSheet-wrapper',
      className,
      moduleName ? moduleName + '-public-share' : '',
    ]"
  >
    <van-popup
      v-model="showPopup"
      :position="isDesktop ? 'center' : 'bottom'"
      class="share-popup-wrapper"
      round
      :get-container="
        getContainer ? getContainer : '.public-shareSheet-wrapper'
      "
    >
      <section class="share-popup-body">
        <p class="title">{{ $t('common.share') }}</p>
        <ul class="share-item-body">
          <li :class="['share-item']">
            <div
              :class="['share-item-options', list.className]"
              v-for="list in shareOptions"
              :key="list.id"
              v-clipboard:copy="list.id === 'copyLink' ? copyText : ''"
              v-clipboard:success="
                list.id === 'copyLink' ? onCopySuccess : () => {}
              "
              v-clipboard:error="
                list.id === 'copyLink' ? onCopyError : () => {}
              "
              @click="goToShare(list)"
            >
              <img
                :class="['share-item-logo', list.id]"
                v-lazy="list.icon"
                alt="logo"
                :title="list.name"
              />
              <span :class="['share-item-name', list.id]">{{ list.name }}</span>
            </div>
          </li>
        </ul>
        <button class="cancel-btn" @click="closePopup">
          {{ $t('common.cancle') }}
        </button>
      </section>
    </van-popup>
  </section>
</template>

<script>
  // 注: 传入的参数和加工方法在mixins中
  import publicShareMobileMixins from '@/mixins/publicShareMobile'

  export default {
    name: 'mobile-share-popup',
    mixins: [publicShareMobileMixins],
    data() {
      return {}
    },
  }
</script>
<style lang="scss" src="./index.scss"></style>
<style scoped lang="scss">
  @media screen and (min-device-width: 1080px) {
    @import './index_pc.scss';
  }
</style>
